export default {
  labels: {
    sold_out: 'Loppuunmyyty!',
    most_popular: '#{{rank}} Suosituin',
    last_ordered: 'Viimeksi tilattu',
  },
};
